import styled from 'styled-components'

export const CurrentOrdersContainer = styled.div`
  padding: .25rem .75rem;
  /* Let the parent grid control vertical sizing; avoid nested 100vh which breaks mobile layout */
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0; /* allow children to scroll inside */
  overflow: hidden;
`
export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: .5rem;

  /* On mobile we will override and show a custom header row */
  @media (max-width: 768px) {
    display: none;
  }
`

export const MainSection = styled.div`
  display: flex;
  gap: 1rem;
  /* Fill remaining space and allow internal scroll instead of fixed % heights */
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const OrdersContainer = styled.div`
  flex: 1;
  border: 1px solid rgb(123,12,31);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
`

export const Header = styled.div`
  padding: .25rem .5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Body = styled.div`
  padding: .25rem .5rem;
`

export const MobileHeader = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: .5rem;
  padding: .5rem .75rem 0;
  margin-bottom: .5rem; /* ligera separación del MainSection */
  }
`

export const Segmented = styled.div`
  display: inline-flex;
  background: #e9ecef;
  border-radius: .5rem;
  padding: .25rem;
  gap: .25rem;
  width: 100%;
  justify-content: center;

  button {
    border: 0;
    background: transparent;
    padding: .25rem .5rem;
    border-radius: .375rem;
    font-size: .9rem;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
  }

  .active {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0,0,0,.05);
  }

  .badge {
    margin-left: .35rem;
    background: #0d6efd; /* azul por defecto */
    color: #fff;
    border-radius: 1rem;
    padding: 0 .4rem;
    font-size: .75rem;
    line-height: 1.2;
  }

  .badge.zero {
    background: #6c757d; /* gris cuando el conteo es 0 */
  }
`

export const CountBadge = styled.span<{ $zero?: boolean }>`
  margin-left: .5rem;
  background: ${p => p.$zero ? '#6c757d' : '#0d6efd'};
  color: #fff;
  border-radius: 1rem;
  padding: 0 .45rem;
  font-size: .8rem;
  line-height: 1.4;
  display: inline-block;
`

export const DesktopOnly = styled.span`
  @media (max-width: 768px) {
    display: none !important;
  }
`